module.exports = __webpack_public_path__ + "static/media/YM39_1.b6895f9d.jpg";